import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },

  props: {
    templatesData: {
      type: Object,
      required: true
    }
  },

  computed: {
    templates() {
      return this.templatesData.templates || []
    }
  },

  template: `
    <settings-container active-tab="message_exception_templates">
      <template slot="content">
        <div class="templates-settings message-exception-templates-settings">
          <div class="templates-header">
            <div>
              <div class="templates-kicker">消息异常模板设置</div>
              <h1>所有消息异常模板</h1>
              <p>管理消息不存在和无权限访问时展示的异常页面模板。</p>
            </div>
          </div>

          <div class="panel-card templates-card">
            <div class="panel-card-head">
              <span class="panel-card-title">模板列表</span>
            </div>
            <div class="panel-card-body">
              <div class="templates-list message-exception-template-list">
                <a v-for="template in templates"
                   :key="template.id"
                   :href="template.paths.show"
                   class="template-list-item">
                  <span class="template-icon"><i class="fa fa-exclamation-circle"></i></span>
                  <span class="template-list-copy">
                    <span class="template-name">{{ template.name }}</span>
                    <span class="template-meta">{{ template.human_type }}</span>
                  </span>
                  <span class="template-action">编辑</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </settings-container>
  `
})
